<div class="links">
  <ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="homeItemDetailWidgetType.Air">
      <app-home-item-link 
        [icon]="icons.Flights"
        [text]="'HOME_ITEM_DETAIL_MODULE.TITLE_FLIGHT_WANT_TO_GO' | transloco"
        [searchType]="searchTypes.HOME_FLIGHT"
        [source]="source"
        (openItem)="setEditSearchByProduct(headerProductType.Air)">
      </app-home-item-link>
    </ng-container>
    <ng-container *ngSwitchCase="homeItemDetailWidgetType.Hotel">
      <app-home-item-link 
        [icon]="icons.Hotels"
        [text]="'HOME_ITEM_DETAIL_MODULE.TITLE_HOTEL_WANT_TO_GO' | transloco"
        [searchType]="searchTypes.HOME_HOTELS"
        [source]="source"
        (openItem)="setEditSearchByProduct(headerProductType.Hotels)">
      </app-home-item-link>
    </ng-container>
    <ng-container *ngSwitchCase="homeItemDetailWidgetType.Byhours">
      <app-home-item-link 
        [icon]="icons.ByHours"
        [text]="'HOME_ITEM_DETAIL_MODULE.TITLE_BYHOURS_TO_GO' | transloco"
        [searchType]="searchTypes.HOME_BYHOURS"
        [source]="source"
        (openItem)="setEditSearchByProduct(headerProductType.ByHours)">
      </app-home-item-link>
    </ng-container>
    <ng-container *ngSwitchCase="homeItemDetailWidgetType.Bus">
      <app-home-item-link 
        [icon]="icons.Buses"
        [text]="'HOME_ITEM_DETAIL_MODULE.TITLE_FLIGHT_WANT_TO_GO' | transloco"
        [searchType]="searchTypes.HOME_BUSES"
        [source]="source"
        (openItem)="setEditSearchByProduct(headerProductType.Air)">
      </app-home-item-link>
    </ng-container>
    <ng-container *ngSwitchCase="homeItemDetailWidgetType.Auto">
      <app-home-item-link 
        [icon]="icons.Autos"
        [text]="'HOME_ITEM_DETAIL_MODULE.TITLE_AUTO_RENTAL' | transloco"
        [searchType]="searchTypes.HOME_AUTOS"
        [source]="source"
        (openItem)="setEditSearchByProduct(headerProductType.Cars)">
      </app-home-item-link>
    </ng-container>
    <ng-container *ngSwitchCase="homeItemDetailWidgetType.Package">
      <app-home-item-link 
        [icon]="icons.Packages"
        [text]="'HOME_ITEM_DETAIL_MODULE.TITLE_WANT_A_PACKAGE' | transloco"
        [searchType]="searchTypes.PACKAGES_HOME"
        [source]="source"
        (openItem)="setEditSearchByProduct(headerProductType.Packages)">
      </app-home-item-link>
    </ng-container>
    <ng-container *ngSwitchCase="homeItemDetailWidgetType.Activities">
      <app-home-item-link 
        [icon]="icons.Activities"
        [text]="'HOME_ITEM_DETAIL_MODULE.TITLE_WANT_AN_ACTIVITY' | transloco"
        [searchType]="searchTypes.TOUR_AND_ACTIVITIES"
        [source]="source"
        (openItem)="setEditSearchByProduct(headerProductType.Activities)">
      </app-home-item-link>
    </ng-container>
  </ng-container>
</div>

<ng-container *ngIf="isMobile">
  <ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="homeItemDetailWidgetType.Air">
      <ng-container *ngTemplateOutlet="searchBarAir"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="homeItemDetailWidgetType.Bus">
      <ng-container *ngTemplateOutlet="searchBarAir"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="homeItemDetailWidgetType.Package">
      <app-swipe-up
        [classType]="swipeStyle"
        [height]="100"
        [title]="'TITLE_SEARCH_HOME' | transloco"
        [showHeader]="true"
        [showSwipeUp]="editSearchIsActivated$(headerProductType.Packages) | async"
        (toggleShowSwipeUp)="setEditSearchByProduct(headerProductType.Packages)">
        <ng-container content>
          <div class="content margin-package">
            <ng-container *ngIf="editSearchIsActivated$(headerProductType.Packages) | async">
              <app-packages-search-bar
                [searchType]="searchTypes.PACKAGES_HOME"
                [source]="source"
                (showMobileCalendarEvent)="showMobileCalendar($event, searchTypes.PACKAGES_HOME)">
              </app-packages-search-bar>
            </ng-container>
          </div>
        </ng-container>
      </app-swipe-up>
    </ng-container>
    <ng-container *ngSwitchCase="homeItemDetailWidgetType.Hotel">
      <app-swipe-up
        [classType]="swipeStyle"
        [height]="100"
        [title]="'TITLE_SEARCH_HOME' | transloco"
        [showHeader]="true"
        [showSwipeUp]="editSearchIsActivated$(headerProductType.Hotels) | async"
        (toggleShowSwipeUp)="setEditSearchByProduct(headerProductType.Hotels)">
        <ng-container content>
          <div class="content">
            <app-hotel-search
              (showMobileCalendarEvent)="showMobileCalendar($event, searchTypes.HOTELS_RESULTS)"
              [searchType]="searchTypes.HOTELS_RESULTS"
              [showSearch]="editSearchIsActivated$(headerProductType.Hotels) | async"
              [source]="source"
              [isMobile]="isMobile"
              [isResults]="true">
            </app-hotel-search>
          </div>
        </ng-container>
      </app-swipe-up>
    </ng-container>
    <ng-container *ngSwitchCase="homeItemDetailWidgetType.Byhours">
      <app-swipe-up
        [classType]="swipeStyle"
        [height]="100"
        [title]="'TITLE_SEARCH_HOME' | transloco"
        [showHeader]="true"
        [showSwipeUp]="editSearchIsActivated$(headerProductType.ByHours) | async"
        (toggleShowSwipeUp)="setEditSearchByProduct(headerProductType.ByHours)">
        <ng-container content>
          <div class="content">
            <app-byhours-search
              [source]="source"
              [isMobile]="true"
              [isResults]="true"
              (showMobileCalendarEvent)="showMobileCalendar($event, searchTypes.BYHOURS_RESULTS)">
            </app-byhours-search>
          </div>
        </ng-container>
      </app-swipe-up>
    </ng-container>
    <ng-container *ngSwitchCase="homeItemDetailWidgetType.Auto">
      <div [ngClass]="{'different-place': isDiffPlace$ | async}">
        <app-swipe-up
          [classType]="swipeStyle"
          [height]="100"
          [title]="'TITLE_SEARCH_HOME' | transloco"
          [showHeader]="true"
          [showSwipeUp]="editSearchIsActivated$(headerProductType.Cars) | async"
          (toggleShowSwipeUp)="setEditSearchByProduct(headerProductType.Cars)">
          <ng-container content>
            <app-auto-search
              [source]="source"
              [searchType]="searchTypes.AUTOS_RESULTS"
              [isMobile]="isMobile"
              [isResults]="true"
              [showSearch]="editSearchIsActivated$(headerProductType.Cars) | async"
              (showMobileCalendarEvent)="showMobileCalendar($event, searchTypes.AUTOS_RESULTS)"
              (redirectToSearch)="redirectToSearch()">
            </app-auto-search>
          </ng-container>
        </app-swipe-up>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="homeItemDetailWidgetType.Activities">
      <app-activities-search-bar
        [source]="source"
        [searchBarBehavior]="searchBarBehavior">
      </app-activities-search-bar>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #searchBarAir>
  <app-search-bar
    [showHeaderMobile]="false"
    [isMobile]="isMobile"
    [isLandingDestination]="isLandingDestination"
    [destination]="landingDestination"
    [source]="source"
    [searchType]="searchAirType"
    [airports]="airports$ | async"
    [airlineCode]="airlineCode"
    (showMobileCalendarEvent)="showMobileCalendar($event, searchAirType)">
  </app-search-bar>
</ng-template>

<router-outlet name="search"></router-outlet>
